import Question from './Question'

/**
 * Checkbox 由很多個選項所組成
 * 程式資料的儲存方式是在 Array 裡面放使用者已經選擇的選項 id
 *
 * Array [
 *   option1
 *   option2
 * ]
 *
**/
export class Checkbox extends Question {
  get defaultValue () {
    return this._questionDefinition.defaultValue || []
  }

  // TODO: use deep-equal
  get isValueDefault () {
    return (this.defaultValue.length === this.value.length &&
        this.value.every(v => this.defaultValue.some(dv => dv.id === v.id)))
  }

  get optionIds () {
    return this._questionDefinition.options
  }

  get options () {
    return this.optionIds.map(oid => this.cartElementBuilder.buildOption(oid, this.stateObj, this._menu))
  }

  get totalPrice () { return parseFloat(this.selectedOptions.map(o => o.totalPrice).reduce((s, p) => s + p, 0)) }
  get hasValue () { return this.value.length !== 0 }
  get selectedOptions () {
    return this.selectedOptionIds.map(oid => this.cartElementBuilder.buildOption(oid, this.stateObj, this._menu))
  }
  get selectedOptionIds () {
    return this.value
  }
  get activeSubQuestions () {
    return this.selectedOptions.reduce((questions, option) => questions.concat(option.questions), [])
  }

  get valueString () { return this.selectedOptions.map(o => o.title).join(', ') }
  get valueStringWithTitle () { return this.title + ': ' + this.selectedOptions.map(o => o.title).join(', ') }
  get errorMessage () { return '點我選: ' + this.title } // TODO: 之後要加上太多或太少的訊息
  optionAmount (optionId) { return this.value.includes(optionId) ? 1 : 0 }
}
